<template>
  <div class="modal light" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card animated zoomIn faster">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ selectedSlot.name }}</p>
        <button class="delete" aria-label="close" @click="closeModal"></button>
      </header>
      <section class="modal-card-body">
        <div
          v-if="this.selectedSlot.code === 'PGSLOT' && hasPgSlotMessage"
          class="slot border"
        >
          <div class="text-alert" v-html="hasPgSlotMessage"></div>
        </div>
        <div
          v-else
          class="slot"
          v-bind:style="{ backgroundImage: `url(${selectedSlot.background})` }"
        >
          <img :src="selectedSlot.logo" />
        </div>
        <div v-if="selectedSlot.isActive">
          <div class="field">
            <label for="" class="label copy"
              >Username
              <span
                class="copy"
                v-clipboard:copy="account.username"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                <i class="fas fa-copy m-l-10"></i>
                {{ $t('modals.invite.copyTxt') }}</span
              ></label
            >
            <div class="control has-icons-left">
              <input
                type="text"
                placeholder="e.g. xxx xxx"
                class="input text-center"
                :value="account.username"
                readonly
              />
              <span class="icon is-small is-left">
                <i class="fas fa-user-tie"></i>
              </span>
            </div>
          </div>
          <div class="field">
            <label for="" class="label copy"
              >Password
              <span
                class="copy"
                v-clipboard:copy="account.password"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                <i class="fas fa-copy m-l-10"></i>
                {{ $t('modals.invite.copyTxt') }}</span
              ></label
            >
            <div class="control has-icons-left">
              <input
                placeholder="*******"
                class="input text-center"
                :value="account.password"
                readonly
              />
              <span class="icon is-small is-left">
                <i class="fa fa-lock"></i>
              </span>
            </div>
            <div>
              <span class="reset m-r-5" @click="handleResetPassword"
                ><i class="fas fa-sync-alt m-r-5"></i
                >{{ $t('modals.slotAccount.resetPasswordTxt') }}</span
              >
              <span class="note"
                >({{ $t('modals.slotAccount.canNotPlayTxt') }})</span
              >
            </div>
            <!-- <div class="field m-t-30">
              <label for="" class="label">{{
                $t('modals.slotAccount.transferToGameLabel')
              }}</label>
              <div class="control has-icons-left">
                <input
                  ref="inputAmount"
                  v-model="amount"
                  type="number"
                  min="0"
                  placeholder="e.g. 100"
                  class="input text-center"
                  required
                />
                <span class="icon is-small is-left">
                  <i class="fas fa-wallet"></i>
                </span>
              </div>
              <div>
                <span class="note">
                  {{ $t('modals.slotAccount.haveAmountTxt') }}
                  {{ selectedSlot.amount | numberFormat }}
                  {{ $t('modals.transfer.bahtTxt') }}
                </span>
              </div>
            </div> -->
          </div>
          <div v-if="selectedSlot.web !== null" class="box-button m-t-10">
            <slot-login
              hidden
              :slot-code="selectedSlot.code"
              :url="selectedSlot.web"
              :account="account"
              :trigger="trigger"
            ></slot-login>
            <button class="button full-100 is-primary" @click="transferAndPlay">
              {{ $t('modals.slotAccount.playGameBtn') }}
            </button>
          </div>
          <div v-else class="box-button m-t-10">
            <button
              class="button full-100 is-primary"
              @click="transferOnly"
              :disabled="amount <= 0"
            >
              {{ $t('modals.slotAccount.transferToGameLabel') }}
            </button>
          </div>
          <div class="box-button m-t-10">
            <button
              class="button full-50 is-success"
              @click="handlePlayOnAndroid(selectedSlot.android)"
              :disabled="selectedSlot.android === null ? true : false"
            >
              {{ $t('modals.slotAccount.androidAppBtn') }}
            </button>
            <button
              class="button full-50 is-info"
              @click="handlePlayOniOS(selectedSlot.ios)"
              :disabled="selectedSlot.ios === null ? true : false"
            >
              {{ $t('modals.slotAccount.iosAppBtn') }}
            </button>
          </div>
        </div>
        <div v-else>
          <div class="box-button m-t-30">
            <button class="button full-100 is-primary" @click="handleActivate">
              {{ $t('modals.slotAccount.activeBtn') }}
            </button>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import apiWallet from '@/api/wallet'
import SlotLogin from '../login/index.vue'
import i18n from '@/language'
export default {
  name: 'ModalSlotAccount',
  components: {
    SlotLogin
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    selectedSlot: {
      type: Object
    },
    wallet: {
      type: Number
    }
  },
  data() {
    return {
      account: {},
      trigger: 0,
      amount: 0,
      hasPgSlotMessage: process.env.VUE_APP_MSG_PGSLOT
    }
  },
  mounted() {
    this.amount = this.wallet

    if (this.isActive && this.selectedSlot.isActive === true)
      this.getSlotAccout()
  },
  methods: {
    async transferAndPlay() {
      if (this.amount <= 0) {
        this.trigger += 1
        return
      }
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try {
        await this.transfer()
        this.trigger += 1
      } catch {}
    },
    async transferOnly() {
      if (this.amount <= 0) {
        this.$refs.inputAmount.focus()
        return
      }
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try {
        await this.transfer()

        this.$emit('closeModal', true)
        this.showSuccessAlert()
      } catch {}
    },
    async transfer() {
      let loading = this.$loading.show()

      return new Promise((resolve, reject) => {
        setTimeout(async () => {
          try {
            const result = await apiWallet.transferAllToGame(
              this.selectedSlot.code
            )
            if (result) {
              resolve()
            }
          } catch (error) {
            this.showErrorAlert(error)
            reject()
          } finally {
            loading.hide()
          }
        }, 200)
      })
    },
    showSuccessAlert() {
      this.$swal(
        i18n.t('modals.successMsg'),
        i18n.t('modals.transferMsg'),
        'success'
      )
    },
    showErrorAlert(text) {
      this.$swal(i18n.t('modals.errorMsg'), text, 'error')
    },
    async getSlotAccout() {
      const data = await apiWallet.accountSlot(this.selectedSlot.code)
      this.account = data
    },
    closeModal() {
      this.$emit('closeModal', null)
    },
    handleActivate() {
      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          await apiWallet.activateSlot(this.selectedSlot.code)
          this.selectedSlot.isActive = true

          await this.getSlotAccout()

          loading.hide()
        } catch {
          loading.hide()
        }
      }, 200)
    },
    handleResetPassword() {
      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          await apiWallet.resetPasswordSlot(this.selectedSlot.code)
          this.selectedSlot.isActive = true

          await this.getSlotAccout()

          loading.hide()
        } catch {
          loading.hide()
        }
      }, 200)
    },
    async handlePlayOnAndroid(url) {
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      let win
      if (this.amount <= 0) {
        win = window.open('about:blank')
        win.location = url

        return
      }

      try {
        await this.transfer()
        win = window.open('about:blank')
        win.location = url
      } catch {}
    },
    async handlePlayOniOS(url) {
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      let win
      if (this.amount <= 0) {
        win = window.open('about:blank')
        win.location = url

        return
      }

      try {
        await this.transfer()
        win = window.open('about:blank')
        win.location = url
      } catch {}
    },
    onCopy(e) {
      this.$buefy.toast.open({
        message: `copied: ${e.text}`,
        type: 'is-success'
      })
    },
    onError() {
      this.$buefy.toast.open({
        message: 'Failed to copy',
        type: 'is-danger'
      })
    }
  }
}
</script>

<style scoped lang="scss">
img {
  width: auto;
  height: 60px;
  margin-top: 20px;
  display: block;
  margin: 0 auto;
}

.modal-card-body {
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover;
}

.slot {
  position: relative;
  background-size: cover;
  background-position: center;
  border-radius: 10px;
  width: 100%;
  height: 150px;
  text-align: center;
  display: block;
  opacity: 0.8;
  padding: 10px;
  margin-bottom: 20px;

  img {
    width: auto;
    height: 100px;
    margin-top: 15px;
  }

  .slot-container {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.4);
    color: #fff;
    bottom: 0;
    min-width: 100%;
    height: 60px;
    text-align: center;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    display: table;

    .slot-content {
      display: table-cell;
      vertical-align: middle;
      .slot-amount {
        font-weight: 700;
        font-size: 18px;
      }
      .slot-title {
        font-size: 12px;
      }
    }
  }

  &.border {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #222;
  }

  .text-alert {
    font-size: 18px;
    color: red;
  }
}

label {
  &.copy {
    &:hover {
      cursor: pointer;
      color: $primary;
    }
  }
}

.reset {
  text-decoration: underline;
  &:hover {
    cursor: pointer;
    color: $primary;
  }
}

.note {
  font-size: 14px;
  color: $danger;
}

.height-0 {
  height: 0px !important;
  visibility: hidden;
}
</style>
